import React from 'react'
import styles from '@/styles/SwishComponent .module.css'
import Image from 'next/image'
import { useTranslation } from 'react-i18next'

const SwishComponent = () => {
  const { t, i18n } = useTranslation()
  return (
    <section className={styles.card}>
      <div className={styles.header}>
        <Image src='/swish.svg' alt='swish' width={40} height={40} />
        <p>{t('Pay with Swish or card')}</p>
      </div>

      <div className={styles.info}>
        <a href='tel:08934910'>📞 08-93 49 10</a>
        <p>📍 Sparres väg 1, Bro</p>
        <p className={styles.web}>www.labambi.se</p>
      </div>
    </section>
  )
}

export default SwishComponent
